/**
 * Validate an IBAN.
 *
 * @param {String}  key - the IBAN.
 *
 * @return {Boolean}
 */
export const validateIBAN = (key) => {
  return key.match(/^([A-Z]{2})(\d{2})([A-Z0-9]{10,30})$/)
}

export const validateAccountFormat = (key, regex) => {
  return key.match(regex)
}

export const validateABA = (key) => {
  return key.match(/^(\d{9})$/)
}

export const validateBSB = (key) => {
  return key.match(/^(\d{6})$/)
}

export const validateSortCode = (key) => {
  return key.match(/^(\d{1,6})$/)
}

export const validateAccountNumber = (key) => {
  return key.match(/^(\d{1,8})$/)
}

export const validateEmail = (key) => {
  return key.match(/^([\w.]{1,})@(\w{1,})(\.(\w{1,})){1,}$/)
}

export const validateSIREN = (key) => {
  return key.match(/^([0-9]{9})$/)
}

export const validatePhoneNumber = (key) => {
  return key.match(/^(?:\+\d{1,3}|0\d{1,3}|00\d{1,2})([0-9]{1,})$/)
}



// WEBPACK FOOTER //
// ./src/helpers/validator.js